import React from "react";
import { useMemo } from "react";
import CustomTable from "../CustomTable";
import RecordCount from "../utils/RecordCount";

const Ndcs = (props) => {
  const mergeNdcsWithNcpdp = () => {
    return props.ndcs.map((ndc) => {
      ndc.hcpcs_code_details = props.ncpdpHcpcsUnitConversions[ndc.formatted_ndc];
      return ndc;
    });
  };

  const columns = useMemo(
    () => [
      {
        Header: "Manufacturer",
        accessor: "manufacturer",
        filter: "fuzzyText",
      },
      {
        Header: "Product Name",
        accessor: "product_name",
        filter: "fuzzyText",
      },
      {
        Header: "Formatted NDC",
        accessor: "formatted_ndc",
        filter: "fuzzyText",
      },
      {
        Header: "Item",
        accessor: "item",
        filter: "fuzzyText",
      },
      {
        Header: "Format",
        accessor: "format",
        filter: "fuzzyText",
      },
      {
        Header: "Network",
        accessor: "network",
        filter: "fuzzyText",
        Cell: (tableProps) => (
          <span className="badge bg-secondary">{tableProps.row.original.network}</span>
        ),
      },
      {
        Header: "Pharmacy",
        accessor: "pharmacy",
        filter: "boolean",
        Cell: (tableProps) => (
          <span className="badge bg-secondary">{tableProps.row.original.pharmacy.toString()}</span>
        ),
      },
      {
        Header: "Medical",
        accessor: "medical",
        filter: "boolean",
        Cell: (tableProps) => (
          <span className="badge bg-secondary">{tableProps.row.original.medical.toString()}</span>
        ),
      },
      {
        Header: "Pharmacy Encounter",
        accessor: "pharmacy_encounter",
        filter: "boolean",
        Cell: (tableProps) => (
          <span className="badge bg-secondary">
            {tableProps.row.original.pharmacy_encounter.toString()}
          </span>
        ),
      },
      {
        Header: "Medical Encounter",
        accessor: "medical_encounter",
        filter: "boolean",
        Cell: (tableProps) => (
          <span className="badge bg-secondary">
            {tableProps.row.original.medical_encounter.toString()}
          </span>
        ),
      },
      {
        Header: "Lookback Days",
        accessor: "lookback_days",
        filter: "fuzzyText",
      },
      {
        Header: "Units of Measure",
        accessor: "ncpdp_units_of_measure",
        filter: "fuzzyText",
        Cell: (tableProps) => tableProps.row.original.ncpdp_units_of_measure.join(", "),
      },
      {
        Header: "HCPCS Code(s) Details",
        accessor: "hcpcs_code_details",
        filter: "fuzzyText",
      },
    ],
    []
  );

  return (
    <React.Fragment>
      {!props.hide_count ? <RecordCount record_count={props.ndcs.length} /> : null}
      {props.ndcs.length > 0 || props.hide_count ? (
        <CustomTable columns={columns} data={mergeNdcsWithNcpdp()} />
      ) : null}
    </React.Fragment>
  );
};

export default Ndcs;
